import React, {
  createContext,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import axios from "axios";
import { BASE_URL } from "./utills/constant";
import i18next from "i18next";
import Cookie from "js-cookie";
import { useTranslation } from "react-i18next";

const AppContext = createContext();

const AppProvider = ({ children }) => {
  //Navbar
  const [navParent, setNavParent] = useState([]);
  //Main Slider
  const [slider, setSlider] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  //All Blogs
  const [allBlogs, setAllBlogs] = useState([]);
  // Call Laboratory
  const [labor, setLabor] = useState([]);
  //Language
  const [selectLang, setSelectLang] = useState("ru");
  // Contrast
  const [showContrast, setShowContrast] = useState(false);
  const [selectContrast, setSelectContrast] = useState(true);
  const [selectFontSmall, setSelectFontSmall] = useState(true);
  const [selectFontBig, setSelectFrontBig] = useState(false);
  const contrastRef = useRef();

  // NEFTGAZMALAKA
  const [training, setTraining] = useState([]);

  // PARTNERS
  const [partners, setPartners] = useState([]);

  const navbarList = () => {
    axios
      .get(BASE_URL + "/api/category/all/sort")
      .then((res) => {
        setNavParent(res.data.object);
        // console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const sliderImage = async () => {
    try {
      setIsLoading(true);
      setError("");

      await axios
        .get(BASE_URL + "/api/blog/all/main_slider")
        .then((res) => {
          setSlider(res.data.object);
          // console.log(res.data.object)
        })
        .catch((err) => {
          console.log(err);
        });
      setError("");
    }catch(err) {
      setError(err);
    }finally {
      setIsLoading(false);
    }
  };

  const callAllBlogs = () => {
    axios
      .get(BASE_URL + "/api/blog/all/9")
      .then((res) => {
        setAllBlogs(res.data.object);
        // console.log(res.data.object);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const callLobor = () => {
    axios
      .get(BASE_URL + "/api/blog/all/56")
      .then((res) => {
        setLabor(res.data.object);
        // console.log(res.data.object);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const callTraining = () => {
    axios
      .get(BASE_URL + "/api/blog/all/57?isText=true")
      .then((res) => {
        setTraining(res.data.object);
        // console.log(res.data.object);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const callPatrners = () => {
    axios
        .get(BASE_URL + "/api/blog/all/58?isText=true")
        .then(res=>{
          setPartners(res.data.object);
        })
        .catch(err=>{
          console.log(err);
        })
  }

  const handlerSelect = (e) => {
    setSelectLang(e.target.value);
    // console.log(e.target.value);
    i18next.changeLanguage(e.target.value);
  };

  const openContrast = () => {
    setShowContrast((prev) => !prev);
  };

  // const openSearch = () => {
  //   setShowSearch((prev) => !prev);
  // };

  const closeContrast = (e) => {
    if (contrastRef.current === e.target) setShowContrast(false);
  };

  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && showContrast) {
        setShowContrast(false);
      }
    },
    [setShowContrast, showContrast]
  );

  const clickStandard = () => {
    setSelectContrast(true);
    localStorage.removeItem("selectCont");
  };
  const clickContrast = () => {
    setSelectContrast(false);
    localStorage.setItem("selectCont", "c");
  };

  const clickFontSmall = () => {
    setSelectFontSmall(true);
    setSelectFrontBig(false);
  };
  const clickFontMedium = () => {
    setSelectFontSmall(false);
    setSelectFrontBig(false);
    var children = document.getElementById("alkash").children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      child.style.cssText = "font-size: px !important;";
    }
  };
  const clickFontBig = () => {
    setSelectFontSmall(false);
    setSelectFrontBig(true);
    var children = document.getElementById("alkash").children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      child.style.cssText = "font-size: px !important;";
    }
  };

  const { t } = useTranslation();
  const Title = (document.title = t("Title"));

  useEffect(async () => {
    setSelectContrast(!localStorage.getItem("selectCont"));
    navbarList();
    await sliderImage();
    callAllBlogs();
    callLobor();
    callTraining();
    callPatrners();
    document.addEventListener("keydown", keyPress);
    return () => document.addEventListener("keydown", keyPress);
  }, [Title, keyPress, selectContrast]);

  const getCookie = Cookie.get();
  // console.log(getCookie)

  const value = {
    navParent,
    slider,
    isLoading,
    error,
    allBlogs,
    labor,
    handlerSelect,
    getCookie,
    selectLang,
    clickContrast,
    selectContrast,
    clickFontSmall,
    clickFontMedium,
    clickFontBig,
    selectFontSmall,
    selectFontBig,
    openContrast,
    showContrast,
    setShowContrast,
    contrastRef,
    closeContrast,
    clickStandard,
    training,
    partners,
  };
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export { AppProvider, AppContext };
